import React, { FC } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import s from './popularArtistsSection.module.scss';
import { useGetPopularArtists } from '@services/artist/hooks/useGetPopularArtists';
import { ArtistCard } from '@components/Cards/ArtistCard/ArtistCard';
import { useMediaQuery } from '@hooks/useMediaQuery';
import { LogoLoader } from '@components/UIKit/LogoLoader/LogoLoader';
import { useTranslation } from '@hooks/useTranslation';
type Props = {};
const id = 'popular_artists_pagination';
export const PopularArtistsSection: FC<Props> = ({}) => {
  const {
    translate: tr
  } = useTranslation();
  const matches = useMediaQuery('(max-width: 991.98px)');
  const {
    data,
    isLoading
  } = useGetPopularArtists({
    limit: matches ? 6 : 15
  });
  return <div className={s.popularArtistsSection} data-sentry-component="PopularArtistsSection" data-sentry-source-file="PopularArtistsSection.tsx">
            <h3 className={s.popularArtistsSection__title}>
                {tr({
        id: 'explore.page.popular.artists.title'
      })}
            </h3>
            {isLoading ? <LogoLoader /> : !!data?.length && <>
                    <div className={s.popularArtistsSection__pagination} id={id} />
                    <div className={s.popularArtistsSection__slider}>
                        <Swiper slidesPerView={matches ? 2 : 5} slidesPerGroup={matches ? 2 : 5} modules={[Pagination]} loop={true} speed={1000} pagination={{
          clickable: true,
          el: `#${id}`,
          type: 'bullets'
        }} preventClicks>
                            {data?.map(props => <SwiperSlide className={s.popularArtistsSection__slide} key={props.id}>
                                    <ArtistCard data={props} />
                                </SwiperSlide>)}
                        </Swiper>
                    </div>
                </>}
        </div>;
};